import {Button, Divider, List, ListItem, Radio, RadioGroup, Stack, Typography, useTheme} from "@mui/joy";
import {applyTransparency} from "../../../../../theme";
import React from "react";
import {useTestRoom} from "../../../../../hooks/useTestRoom";
import {QuestionGroup, RawQuestion} from "../../../../../models/question";


const IeltsMultipleChoiceQuestionComponent = (props: {
    question: RawQuestion,
    questionGroupIndex: number,
    parentQuestion: QuestionGroup
}) => {
    const theme = useTheme()
    const testRoom = useTestRoom()
    const questionAttempt = testRoom.questionAttempts?.find(value => {
        return value.questionId === props.parentQuestion.id && value.questionGroupIndex === props.questionGroupIndex
    })
    const previousQuestionsCount = testRoom.questions
        .filter(q => q.subSectionNumber < testRoom.currentSubsectionNumber)
        .reduce((sum, q) => sum + (q as QuestionGroup).questions.length, 0)
    const questionNumber = previousQuestionsCount + props.questionGroupIndex + 1

    return <Stack gap={2}>
        <Stack>
            <Typography level={"title-lg"}>
                Question {questionNumber}
            </Typography>
            <Typography>
                {props.question.content}
            </Typography>
        </Stack>


        <RadioGroup value={questionAttempt?.userAnswer as string} size={"sm"}
                    onChange={(event) => testRoom.answerQuestion(event.target.value, props.question, {
                        questionGroupIndex: props.questionGroupIndex,
                        questionId: props.parentQuestion.id,
                        contentType: props.parentQuestion.contentType,
                        testId: props.parentQuestion.testId,
                        sectionName: props.parentQuestion.sectionName,
                        isFromGroup: true
                    })}>
            <List
                sx={{
                    minWidth: 240,
                    '--List-gap': '0.8rem',
                    '--ListItem-paddingY': '1rem',
                    '--ListItem-radius': '8px',
                    '--ListItemDecorator-size': '32px',
                }}>

                {Object.keys(props.question?.metadata['options'])?.map((item, index) => (
                    <ListItem variant="outlined"
                              key={item}
                              sx={{
                                  borderRadius: 15,
                                  backgroundColor: applyTransparency(theme.palette.neutral['400'], 0.2)
                              }}>
                        <Radio
                            overlay
                            value={item}
                            label={<Typography textColor={"text.secondary"}>
                                {props.question?.metadata['options'][item]}
                            </Typography>}
                            color={item === questionAttempt?.userAnswer as string ? "primary" : "neutral"}
                            sx={{flexGrow: 1, color: "secondary.500"}}
                            slotProps={{
                                action: ({checked}) => ({
                                    sx: (theme) => ({
                                        ...(checked && {
                                            inset: -1,
                                            border: '2px solid',
                                            borderRadius: 15,
                                            backgroundColor: applyTransparency(theme.palette.primary[500], 0.3),
                                            borderColor: theme.palette.primary[500],
                                        }),
                                    }),
                                }),
                            }}
                        />
                    </ListItem>
                ))}
            </List>
        </RadioGroup>
    </Stack>
}

export default IeltsMultipleChoiceQuestionComponent